"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appApiRejectionsLoggerMiddleware = exports.isActionErrWithMessage = exports.isForbiddenActionErr = exports.isInternalServerActionErr = exports.isNotFoundActionErr = void 0;

var _toolkit = require("@reduxjs/toolkit");

var _ramda = require("ramda");

var _handleError = require("../../ApiService/handleError");

var _globalMessage = require("../../GlobalMessage/store/globalMessage.actions");

var _GlobalMessage = require("../../GlobalMessage/types/GlobalMessage.types");

var isNotFoundActionErr = function isNotFoundActionErr(action) {
  return (0, _ramda.pathEq)(['status'], 404)(action.payload);
};

exports.isNotFoundActionErr = isNotFoundActionErr;

var isInternalServerActionErr = function isInternalServerActionErr(action) {
  return (0, _ramda.pathSatisfies)((0, _ramda.lte)(500), ['status'])(action.payload);
};

exports.isInternalServerActionErr = isInternalServerActionErr;

var isForbiddenActionErr = function isForbiddenActionErr(action) {
  return (0, _ramda.pathEq)(['status'], 403)(action.payload);
};

exports.isForbiddenActionErr = isForbiddenActionErr;

var isActionErrWithMessage = function isActionErrWithMessage(action) {
  return (0, _ramda.pathSatisfies)((0, _ramda.is)(String), ['data', 'error', 'message'])(action.payload);
};

exports.isActionErrWithMessage = isActionErrWithMessage;

var appApiRejectionsLoggerMiddleware = function appApiRejectionsLoggerMiddleware(api) {
  return function (next) {
    return function (action) {
      if ((0, _toolkit.isRejectedWithValue)(action)) {
        if (isInternalServerActionErr(action)) {
          api.dispatch((0, _globalMessage.showGlobalMessage)({
            text: _handleError.MESSAGES.INTERNAL_SERVER_ERR,
            type: _GlobalMessage.MessageType.Error
          }));
        }

        if (isForbiddenActionErr(action)) {
          api.dispatch((0, _globalMessage.showGlobalMessage)({
            type: _GlobalMessage.MessageType.Error,
            text: _handleError.MESSAGES.PERMISSION_DENIED_ERR
          }));
        }

        if (isActionErrWithMessage(action)) {
          api.dispatch((0, _globalMessage.showGlobalMessage)({
            type: _GlobalMessage.MessageType.Error,
            text: action.payload.data.error.message
          }));
        }
      }

      return next(action);
    };
  };
};

exports.appApiRejectionsLoggerMiddleware = appApiRejectionsLoggerMiddleware;